// extracted by mini-css-extract-plugin
export default {"tag":"pinPostTag_tag__fcAMb","dislikeIcon":"pinPostTag_dislikeIcon__QlivS"};